// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__3ANSi","paper":"styles_paper__ykMjZ","content":"styles_content__PxuFS"};